import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, useWindowDimensionsHook } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import constants from '../../event.statics'
import VenueDetails from './venueDetails'
import VenuesExpandable from './venuesExpandable'
import VenuesTable from './venuesTable'
import VenuesMobileTable from './venuesMobileTable'
import styles from './styles.scss'
import VenuesMobileModalContent from './venuesMobileModalContent'
const cx = classnames.bind(styles)

const Venues = ({
  elmId,
  venues,
  onChangeVenues,
  isOnline,
  selected,
  event,
  filteredDate,
}) => {
  const [openLightbox, setOpenLightbox] = useState(false)
  const [mobileSelected, setMobileSelected] = useState(selected)
  const [openDetails, setOpenDetails] = useState({})

  const { width } = useWindowDimensionsHook()

  useEffect(() => {
    if (selected !== mobileSelected) {
      setMobileSelected(selected)
    }
  }, [selected, mobileSelected])

  const onChangeMobileVenues = selectedValue => {
    setMobileSelected(selectedValue)
  }

  const submitMobileVenues = () => {
    onChangeVenues(mobileSelected)
    setOpenLightbox(false)
  }

  const toggleLightBox = value => {
    setOpenLightbox(value)
  }

  const toggleDetails = venueId => {
    const isOpen = openDetails[venueId] === true
    const newState = Object.assign({}, openDetails)
    newState[venueId] = !isOpen
    setOpenDetails(newState)
  }
  const isSmallScreen = width < constants.BREAKPOINTS.medium

  return (
    <div className={cx('venues-container', { online: isOnline })}>
      <Button
        elmId={elmId + '_venues_button_mobile'}
        className={cx(
          'show-on-tablet',
          'button-is-stretch',
          'mobile-show-venues-btn'
        )}
        onClick={() => toggleLightBox(true)}
        role='secondary'
      >
        Event Times And Details
      </Button>
      <VenuesExpandable
        elmId={elmId}
        event={event}
        className={cx('hide-on-tablet')}
      >
        <VenuesTable
          className={cx('venues-table')}
          elmId={elmId}
          venues={venues}
          isOnline={isOnline}
          selected={selected}
          filteredDate={filteredDate}
          onChangeVenues={onChangeVenues}
          openDetails={openDetails}
          onToggleDetails={toggleDetails}
        />
      </VenuesExpandable>
      <Modal
        elmId={elmId + '_venues_lightbox_mobile'}
        title='Event Times and Details'
        open={openLightbox && isSmallScreen}
        onClose={() => toggleLightBox(false)}
        fullScreen='mobileOnly'
      >
        <VenuesMobileModalContent
          elmId={elmId}
          onChangeMobileVenues={onChangeMobileVenues}
          submitMobileVenues={submitMobileVenues}
          openDetails={openDetails}
          filteredDate={filteredDate}
          mobileSelected={mobileSelected}
          isOnline={isOnline}
          venues={venues}
          onChangeVenues={onChangeVenues}
          onToggleDetails={toggleDetails}
        />
      </Modal>
    </div>
  )
}

Venues.propTypes = {
  elmId: PropTypes.string.isRequired,
  venues: PropTypes.array.isRequired,
  onChangeVenues: PropTypes.func.isRequired,
  isOnline: PropTypes.bool.isRequired,
  selected: PropTypes.array,
  event: PropTypes.object.isRequired,
  filteredDate: PropTypes.string,
}

export default Venues
export {
  VenuesExpandable,
  VenuesTable,
  VenuesMobileTable,
  VenueDetails,
  VenuesMobileModalContent,
}
